import { useParams } from 'react-router';

const SingleSitrep: React.FC = () => {
  const { sitrepId } = useParams<{ sitrepId: string }>();
  return (
    <>
      <h4 className="m-0">Sitrep</h4>
      <p>Single sitreps will be displayed here.</p>
      {sitrepId ? (
        <div
          style={{
            overflowY: 'auto',
          }}
        >
          sitrepId: {sitrepId}
        </div>
      ) : (
        <p>Selected sitrep can not be found</p>
      )}
    </>
  );
};

export default SingleSitrep;
